<template>
	<div>
		<div class="clear"></div>
		<!--container 开始-->
		<!--店铺banner 开始-->
		<div class="hq-shop-banner"><img src="../../static/images/temp/shop/dp-banner.jpg" width="1400" height="120"></div>
		<!--店铺banner 结束-->
		<!--店铺导航 开始-->
		<div class="hq-shop-header">
			<div class="w1200 bc bd">
				<ul class="hq-shop-nav">
					<li class="hover">
						<a href="#">首页</a>
					</li>
					<li class="all-goods pr" v-on:mouseenter="goodsCateShow()" v-on:mouseleave="goodsCateHidden()">
						<router-link :to="{path:'/shop_goods_list'}">全部商品<i class="dp-ico-a-1"></i></router-link>
						<ol class="categorys-dropdown none">
							<li>
								<a href="#">专利</a>
							</li>
							<li>
								<a href="#">能源动力</a>
							</li>
							<li>
								<a href="#">通信电子</a>
							</li>
							<li>
								<a href="#">机械加工</a>
							</li>
							<li>
								<a href="#">电池</a>
							</li>
							<li class="last">
								<a href="#">家电</a>
							</li>
						</ol>
					</li>
					<li>
						<a href="#">企业介绍</a>
					</li>
					<li>
						<a href="#">店铺留言</a>
					</li>
					<li>
						<a href="#">店铺评价</a>
					</li>
				</ul>
				<div class="hq-shop-zx fr">
					<a class="a-btn-zx" href="javascript:void(0);">咨询／收藏<i class="dp-ico-a-1"></i></a>
					<div class="zx-drop-box">
						<div class="item-1">
							<i class="dp-ico-arrw"></i>
							<p>店铺等级：<span class="dp-ico-dpdj"></span><span class="dp-ico-dpdj"></span><span class="dp-ico-dpdj"></span></p>
							<p>信用等级： v6 <span class="dp-ico-xydj"></span></p>
						</div>
						<div class="item-2">
							<a class="a-btn-zxzx" href="#"><i class="dp-ico-zxzx"></i>在线咨询</a>
							<a class="a-btn-scbd ml10" href="#"><i class="dp-ico-scbd"></i>收藏本店</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--店铺导航 结束-->
	</div>
</template>

<script>
	export default {
		name: 'shopnav',
		data() {
			return {
				msg: 'Welcome to Your Vue.js App123'
			}
		},
		methods:{
			goodsCateShow:function(){
				$(".categorys-dropdown").show();
			},
			goodsCateHidden:function(){
				$(".categorys-dropdown").hide();
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/ShopNav.vue